import { useSelector } from 'react-redux';

import { getUTCFormatOfLocalTime } from '@helpers';
import { selectDashboardDateRangeSelection } from '@reducers/v2/dashboard/dashboard.slice';

export const useManageDashboardDrilldownNcFileBody = () => {
  const { from, to } = useSelector(selectDashboardDateRangeSelection);

  return {
    startedOn: from ? getUTCFormatOfLocalTime(from) : from,
    endedOn: to ? getUTCFormatOfLocalTime(to) : to,
  };
};
